import { Component, OnInit } from '@angular/core';
import { Meta } from '../common/seo.service';
import { SwiperModule } from 'angular2-useful-swiper';

var mySettingsx;

@Component({
  selector: 'app-home',
  templateUrl: '../themes/default/html/home.component.html', 
  styleUrls: ['../themes/default/css/home.component.scss'],
  providers: [  ], 
})

export class HomeComponent {

  globals: any;
  Description: any;
  _mySettings: any;

  constructor(private myMeta: Meta ) {    
    myMeta.setTitle("Home page");
  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/home/home.component.ts